// React
import { useCallback } from 'react';

// Models
import { useStores } from 'models';

// Interfaces
import {
  IAssessmentRelevantProofGetListAttrs,
  IAssessmentRelevantProofDownloadDocumentAttrs,
} from 'interfaces/back-office/assessment/registration/relevant-proof/relevant-proof-view.interface';

const useAssessmentRelevantProof = () => {
  // Hook
  const {
    assessmentRelevantProof: {
      assessmentRelevantProof_loading,
      assessmentRelevantProof_list,
      assessmentRelevantProof_CLEAR_LIST,
      assessmentRelevantProof_fetchList: fetchList,
      assessmentRelevantProof_downloadDocument: downloadDocument,
    },
  } = useStores();

  /**
   * @description Fetch assessment relevant proof list
   *
   * @param {IAssessmentRelevantProofGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentRelevantProof_fetchList = useCallback(
    (payload: IAssessmentRelevantProofGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        });
      });
    },
    [fetchList],
  );

  /**
   * @description Download assessment relevant proof document
   *
   * @param {IAssessmentRelevantProofDownloadDocumentAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentRelevantProof_downloadDocument = useCallback(
    (payload: IAssessmentRelevantProofDownloadDocumentAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        downloadDocument({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        });
      });
    },
    [downloadDocument],
  );

  return {
    assessmentRelevantProof_loading,
    assessmentRelevantProof_list,
    assessmentRelevantProof_CLEAR_LIST,
    assessmentRelevantProof_fetchList,
    assessmentRelevantProof_downloadDocument,
  };
};

export { useAssessmentRelevantProof };
